<template>
  <v-dialog v-model="isActive" persistent scrollable max-width="500">
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Transferir chat ({{ selectedOption }})
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true }
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- Agents -->
              <v-col v-if="transferType === 'user'" cols="12" class="py-0">
                <ValidationProvider
                  name="agentes conectados"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :disabled="isLoading"
                    v-model="selectedOption"
                    :items="agentList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-account"
                    label="Agentes conectados"
                    filled
                    rounded
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item
                        two-line
                        selectable
                        v-on="on"
                        v-bind="attrs"
                        class="pl-3"
                      >
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.name + " " }}
                            </v-list-item-title>

                            <v-list-item-subtitle>
                              {{ item.number }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-select>
                </ValidationProvider>
              </v-col>

              <!-- Colas -->
              <v-col v-else-if="transferType === 'queue'" cols="12">
                <ValidationProvider
                  name="Cola"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-autocomplete
                    :disabled="isLoading"
                    :items="queueList"
                    item-text="name"
                    item-value="id"
                    required
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    label="Cola"
                    name="number"
                    prepend-inner-icon="mdi-numeric"
                    color="blue-grey"
                    v-model="selectedOption"
                    :error-messages="errors"
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item
                        two-line
                        selectable
                        v-on="on"
                        v-bind="attrs"
                        class="pl-3"
                      >
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.name + " " }}
                            </v-list-item-title>

                            <v-list-item-subtitle>
                              {{ item.number }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            Transferir
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
// import axios from "axios";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  name: "contactDetailsDialog",

  props: {
    isActive: Boolean,
    currentAgentId: Number,
    transferType: String
  },

  data() {
    return {
      isLoading: false,
      agentList: [],
      queueList: [],
      selectedOption: null
    };
  },

  mounted() {
    if (this.transferType === "user") this.getAgents();
    else if (this.transferType === "queue") this.getQueues();
  },

  methods: {
    closeDialog(value) {
      this.$emit("dialog:close", value);
    },

    getIsGroup() {
      const contact = this.contactList.find(
        (el) => el.id === this.payload.contactId
      );

      this.payload.isGroup = contact.isGroup;
    },

    async getQueues() {
      try {
        const { data } = await PbxHttpClient.get("/clients/index_whatsapp");
        // console.log("colas:", data);
        this.queueList = data.data;
      } catch (err) {
        console.log(err);
      }
    },

    getAgents() {
      this.isLoading = true;

      PbxHttpClient.get(
        `${process.env.VUE_APP_ROOTAPI}/clients/show/agents?page=1&itemPerPage=-1&online=1`
      )
        .then((res) => {
          this.agentList = res.data.data;

          if (this.currentAgentId != null) {
            const foundItem = this.agentList.filter(
              (item) => item.id === this.currentAgentId
            )[0];
            const foundIndex = this.agentList.indexOf(foundItem);
            if (foundIndex > -1) {
              this.agentList.splice(foundIndex, 1);
            }
          }
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    submitForm() {
      const value = this.selectedOption;
      this.closeDialog(value);
    }
  }
};
</script>
